import { useEffect, useState } from "react";


export function SongOfTheDay(){

  const [song,setSong] = useState(null);


useEffect(() => {
  async function loadSong() {
    try {
      console.log("Loading Song of the Day from local library...");

      const response = await fetch("/data/song_library.json");

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const library = await response.json();

      const librarySongs = [...(library.songs || [])].sort(
        (a, b) => a.id - b.id
      );

      if (!librarySongs.length) {
        throw new Error("Music library contains no songs.");
      }

      // Match the daily rotation used by the old backend.
      const today = new Date();

      const dateKey =
        today.getUTCFullYear() * 10000 +
        (today.getUTCMonth() + 1) * 100 +
        today.getUTCDate();

      const songIndex = dateKey % librarySongs.length;
      const selectedSong = librarySongs[songIndex];

      console.log("Song of the Day:", selectedSong);

      setSong({
        ...selectedSong,
        url: selectedSong.url || selectedSong.file,
      });
    } catch (error) {
      console.error("Failed loading song:", error);
    }
  }

  loadSong();
}, []);



  if(!song){
    return null;
  }



  return (

    <section
      className="
      mx-auto
      max-w-6xl
      px-6
      py-12
      "
    >

      <div
        className="
        border
        border-matrix-green/30
        bg-black/50
        p-6
        "
      >

        <div
          className="
          font-mono
          text-matrix-green
          "
        >
          SONG OF THE DAY
        </div>


        <h2
          className="
          text-white
          text-3xl
          font-bold
          "
        >
          {song.title}
        </h2>


        <p
          className="
          text-white/50
          font-mono
          "
        >
          {song.genre} // {song.year}
        </p>

      </div>

    </section>

  );

}